var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNimocaCardBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#nimoca-card-back_svg__filter0_d_0_34382)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 171.504,
    height: 107.558,
    rx: 3.972,
    fill: "url(#nimoca-card-back_svg__paint0_linear_0_34382)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 10.25,
    width: 171.004,
    height: 107.058,
    rx: 3.722,
    stroke: "url(#nimoca-card-back_svg__paint1_linear_0_34382)",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "nimoca-card-back_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 172,
    height: 108
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 10.25,
    width: 171.004,
    height: 107.058,
    rx: 3.722,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nimoca-card-back_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444A55",
    d: "M81.604 103.76h99.681v13.91H81.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF4",
    d: "M9.85 20.158h171.435v13.98H9.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5 111.5a1 1 0 100-2 1 1 0 000 2zM103.5 111.5a1 1 0 100-2 1 1 0 000 2zM108.5 111.5a1 1 0 100-2 1 1 0 000 2zM116 111.5a1 1 0 100-2 1 1 0 000 2zM121 111.5a1 1 0 100-2 1 1 0 000 2zM126 111.5a1 1 0 100-2 1 1 0 000 2zM131 111.5a1 1 0 100-2 1 1 0 000 2zM138.5 111.5a1 1 0 100-2 1 1 0 000 2zM143.5 111.5a1 1 0 100-2 1 1 0 000 2zM148.5 111.5a1 1 0 100-2 1 1 0 000 2zM153.5 111.5a1 1 0 100-2 1 1 0 000 2zM161.5 111.5a1 1 0 100-2 1 1 0 000 2zM166.5 111.5a1 1 0 100-2 1 1 0 000 2zM171.5 111.5a1 1 0 100-2 1 1 0 000 2zM176.5 111.5a1 1 0 100-2 1 1 0 000 2zM89.201 108.256h.985v4.285h-1.055l-2.04-3.021v3.021h-.985v-4.285h1.126l1.97 3.021v-3.021z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.196 108.256h-2.602v4.356h1.054v-1.687h1.056c.773 0 .844.282.844.844 0 .421.07.632.14.843h1.126v-.141c-.211-.07-.211-.211-.211-.843 0-.843-.211-.984-.633-1.124.492-.141.774-.562.774-1.054 0-.351-.211-1.194-1.548-1.194zm.492 1.335c0 .421-.21.562-.773.562h-1.267v-1.124h1.337c.563 0 .703.351.703.562z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.73 17.348l-3.94-1.546 3.94-1.475v3.02z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nimoca-card-back_svg__paint0_linear_0_34382",
    x1: -73.192,
    y1: 66.989,
    x2: 24.928,
    y2: 218.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nimoca-card-back_svg__paint1_linear_0_34382",
    x1: -75.752,
    y1: 63.779,
    x2: 21.075,
    y2: 218.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCE3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "nimoca-card-back_svg__filter0_d_0_34382",
    x: 0,
    y: 0,
    width: 191.504,
    height: 127.558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.831373 0 0 0 0 0.831373 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_34382"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_34382",
    result: "shape"
  })))));
}
export default SvgNimocaCardBack;